import React, { useState } from "react";
import "./ConnectWhatsApp.css";
import HeadingSection from "../HeadingSection/HeadingSection";
import ListConnectWhatsAppFeature from "./ListConnectWhatsAppFeature/ListConnectWhatsAppFeature";
import OTPModal from "./OTPModal/OTPModal";
import { useDispatch, useSelector } from "react-redux";
import UNIVERSAL from "../../../config/config";
import BusinessWhatsappImg from "../../../assets/images/bg.svg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchHomepageProfile } from "../../../store/homepage-profile-slice";

const ConnectWhatsApp = () => {
  const user = useSelector((state) => state?.user?.user);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [enteredNumber, setEnteredNumber] = useState();
  const [verifyNumber, setVerifyNumber] = useState();
  const [appRefId, setAppRefId] = useState();
  
  const navigate = useNavigate()
  const dispatch = useDispatch()

  function handleEnteredNumber(event) {
    setEnteredNumber(event.target.value);
  }

  console.log(String(user?.app_business_id));

  async function handleOpenOtpModal() {
    if (enteredNumber.length > 9) {
      return fetch(UNIVERSAL.BASEURL_1 + "/bizv2/whatsapp/send_verification_code", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
        },
        body: JSON.stringify({
          business_id: String(user?.app_business_id),
          whatsapp_number: enteredNumber,
          country_dialling_code: "91",
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          console.log(responseJson);
          if (responseJson.data.success === false) {
            setVerifyNumber(false);
          } else {
            setAppRefId(responseJson.data.app_reference_id);
           
            setVerifyNumber(true);
            if (responseJson.data.is_verified) {
              fetch(UNIVERSAL.BASEURL_2 + "/user/api/v1/business/whatsapp/validate", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  app_business_id: user?.app_business_id,
                }),
              })
                .then((response) => response.json())
                .then((responseJson) => {
                  console.log(responseJson, "VALIDATE RES")
                  if (responseJson?.data?.is_valid_business_whatsapp_number) {
                    setVerifyNumber(true);
                    toast("Whatsapp account is verified and linked", { type: "success" });
                    dispatch(fetchHomepageProfile({ businessId: user?.app_business_id }));
                    navigate("/profile")
                  } else {
                    setIsBusinessAssociated(false);

                  }
                });
              fetch(UNIVERSAL.BASEURL_1 + "/bizv2/social/connect_accounts", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe"
                  },
                  body: JSON.stringify({
                    messenger: false,
                    instagram: false,
                    whatsapp: true,
                    business_id:user?.app_business_id,
                  }),
                })
                  .then((response) => response.json())
                  .then((responseJson) => {
                 
                  });
            }else {
              // setVerifyNumber(true);
              setShowOtpModal(true);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      return;
    }
    setShowOtpModal(true);
  }
  function handleCloseOtpModal() {
    setShowOtpModal(false);
  }

  return (
    <div id="connectWhatsApp">
      <HeadingSection center heading="Connect whatsapp to your page" note="Please connect your whatsapp business to boost visibility and engagement, then to build te brand trust " />
      <div className="connectWhatsApp-container">
        <div className={verifyNumber === false ? "connectWhatsApp-imgDiv-error" : "connectWhatsApp-imgDiv"}>
          <img
            src={BusinessWhatsappImg}
            alt="connectWhatsApp-img"
            className={verifyNumber === false ? "connectWhatsApp-img-error" : "connectWhatsApp-img"}
          />
        </div>
        <div className="connectWhatsApp-info-outerDiv">
          <div className="connectWhatsApp-info-innerDiv">
            <h3 className="connectWhatsApp-heading">Connect Business Whatsapp to your page</h3>
            <p className="connectWhatsApp-subHeading">Please connect your whatsapp business to boost visibility and engagement, then to build te brand trust </p>
            <hr className="connectWhatsApp-hr" />
            <ul className="ListConnectWhatsAppFeature-lists-feature">
              <ListConnectWhatsAppFeature
                img="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/BoostVisibility.svg"
                heading="Boost Visibility and Engagement"
                subHeading="Advertise your WhatsApp Business account to reach more customers."
              />
              <ListConnectWhatsAppFeature
                img="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/Streamlined.svg"
                heading="Streamlined Customer Communication"
                subHeading="Easy customer inqueries and quick automated responses."
              />
              <ListConnectWhatsAppFeature
                img="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/BuildTrust.svg"
                heading="Build Brand Trust"
                subHeading="Connecting WhatsApp Business account increases customer trust."
              />
            </ul>
            <hr className="connectWhatsApp-hr" />
            <p className="connectWhatsApp-number-text-heading">Your business whatsapp number</p>
            <div className="connectWhatsappNumberDiv">
              <div>
                <div className={verifyNumber === false ? "connectWhatsApp-inputNumber-invalid" : "connectWhatsApp-inputNumber"}>
                  <div class="input-group mb-3 connectWhatsApp-inputNumber-mb-3">
                    <button class="btn btn-outline-secondary dropdown-toggle connectWhatsApp-dropdown-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <img src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/flag.svg" alt="flag-img" /> +91
                    </button>
                    <ul class="dropdown-menu">{/* <li><a class="dropdown-item" href="#">Action</a></li> */}</ul>
                    <input
                      type="text"
                      class="form-control connectWhatsApp-number-input"
                      aria-label="Text input with dropdown button"
                      maxLength="10"
                      onChange={handleEnteredNumber}
                    />
                    {verifyNumber === false && (
                      <img className="connectWhatsApp-number-invalid" src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/RedCross.svg" alt="cross-img" />
                    )}
                    {verifyNumber === true && (
                      <img className="connectWhatsApp-number-valid" src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/GreenTick.svg" alt="tick-img" />
                    )}
                  </div>
                </div>
              </div>
              <div className="sendWhatsAppCodeBtnDiv">
                <button className={enteredNumber && enteredNumber.length > 9 ? "sendWhatsAppCodeBtn" : "disabledSendWhatsAppCodeBtn"} onClick={handleOpenOtpModal}>
                  Send whatsapp code
                </button>
              </div>
            </div>
            {verifyNumber === false && (
              <p className="connectWhatsApp-number-invalid-para">The number isn't associated with WhatsApp. please review the number and try connecting another account</p>
            )}
          </div>
        </div>
      </div>
      {showOtpModal && <OTPModal closeOtpModal={handleCloseOtpModal} appRefId={appRefId} enteredNumber={enteredNumber} />}
    </div>
  );
};

export default ConnectWhatsApp;
